import React from 'react'
import { Icon } from '@chakra-ui/icons'
import { FaCirclePlay } from 'react-icons/fa6'
import { Box, Center } from '@chakra-ui/react'
import { useDisclosure } from '@chakra-ui/react'

import { AttachmentItemProps } from '.'
import RemoveAttachmentButton from './remove-button'
import FullScreenPreview from './full-screen-preview'

export default function PhotoAttachment({
    attachment,
    onRemove,
}: AttachmentItemProps) {
    const { isOpen, onOpen, onClose } = useDisclosure()

    return (
        <>
            <Box
                aspectRatio={1}
                height="full"
                bg="gray.100"
                overflow="hidden"
                borderRadius="lg"
                position="relative"
                _dark={{
                    bg: 'gray.800',
                }}
                role="group"
                cursor="pointer"
            >
                <Box
                    as="video"
                    src={attachment.url}
                    h="full"
                    w="full"
                    objectFit="cover"
                />
                <Center
                    position="absolute"
                    top={0}
                    right={0}
                    left={0}
                    bottom={0}
                    bg="blackAlpha.200"
                >
                    <Icon
                        as={FaCirclePlay}
                        fontSize="5xl"
                        color="whiteAlpha.700"
                    />
                </Center>
                <Box
                    position="absolute"
                    top={0}
                    right={0}
                    bottom={0}
                    left={0}
                    _groupHover={{ bg: 'blackAlpha.200' }}
                    onClick={onOpen}
                />
                {onRemove && <RemoveAttachmentButton onClick={onRemove} />}
            </Box>
            <FullScreenPreview
                attachment={attachment}
                isOpen={isOpen}
                onClose={onClose}
                showDownload={true}
            />
        </>
    )
}
